import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExamTimerService } from './exam-timer.service';

export interface ICurrentTimeInfo {
  currentTime: Date;
  isLastTen: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CurrentTimeService {
  private now: BehaviorSubject<ICurrentTimeInfo | undefined> = new BehaviorSubject(undefined);
  private timer;
  private remainingTime: number; // in milliseconds

  get currentTime(): Observable<ICurrentTimeInfo | undefined> {
    return this.now.asObservable();
  }

  constructor(
    private readonly timerService: ExamTimerService
  ) {
    this.timerService.remainingTimeMillis.subscribe(time => this.remainingTime = time);
  }

  start(): void {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.now.next({ currentTime: new Date(), isLastTen: this.remainingTime <= 9 * 60 * 1000 }); // 9min 59 sec
      }, 1000);
    }
  }

  stop(): void {
    clearInterval(this.timer);
    this.timer = undefined;
    this.now.next(undefined);
  }
}
